import { createAction, props } from '@ngrx/store'
import {
    AttachmentDto, ContractGroupDto, ContractOwnerParamDto, ContractParcelData,
    ContractRelatedDto, ContractResponseDto,
    ContractSignatureDocumentDto, Drupoz,
    IncomingPaymentDto, OutgoingPaymentGroupedByYearContractDto,
    ParcelResponseDto, Subject, Zpvypo,
} from '../../../../../api/backend'

export const SOURCE = '[Contract Show]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)
// Contract
export const setContract = createAction(
    `${SOURCE} SetContract`, props<{ contract: ContractResponseDto }>()
)
export const updateContractOwners = createAction(
    `${SOURCE} UpdateContractOwners`, props<{ owners: Subject[] }>()
)
export const updateContractTenants = createAction(
    `${SOURCE} UpdateContractTenants`, props<{ tenants: Subject[] }>()
)
export const resetContract = createAction(`${SOURCE} ResetContract`)
// Contract update
export const setContractEnd = createAction(
    `${SOURCE} SetContractEnd`, props<{ endDate: string; endType: string; resignDate: string; expirationDate: string }>()
)
export const setContractIsWatched = createAction(
    `${SOURCE} SetContractIsWatched`, props<{ isWatched: boolean }>()
)
export const setContractNote = createAction(
    `${SOURCE} SetContractNote`, props<{ note: string }>()
)
export const setContractWatchReason = createAction(
    `${SOURCE} SetContractWatchReason`, props<{ watchReason: string }>()
)
export const setContractCpds = createAction(
    `${SOURCE} SetContractCpds`, props<{ cpds: ContractParcelData[] }>()
)
export const setContractOwnerParams = createAction(
    `${SOURCE} SetContractOwnerParams`, props<{ ownerParams: ContractOwnerParamDto[] }>()
)
// Attachments
export const setAttachments = createAction(
    `${SOURCE} SetAttachments`, props<{ attachments: AttachmentDto[] }>()
)
export const setAttachmentsLoading = createAction(
    `${SOURCE} SetAttachmentsLoading`, props<{ attachmentsLoading: boolean }>()
)
export const setAttachmentOnlineDocumentLink = createAction(
    `${SOURCE} SetAttachmentOnlineDocumentLink`, props<{ id: number; link: string }>()
)
// Parcels
export const prepareSetParcels = createAction(
    `${SOURCE} PrepareSetParcels`, props<{ parcels: ParcelResponseDto[]; drupozs: Drupoz[]; zpvypos: Zpvypo[]; parcelsOrder?: {sortedBy: string; desc: boolean} }>()
)
export const setParcels = createAction(
    `${SOURCE} SetParcels`, props<{ parcels: ParcelResponseDto[] }>()
)
export const orderParcels = createAction(
    `${SOURCE} OrderParcels`, props<{ orderBy: string; parcelsOrder: any }>() // Effect
)
// RelatedContracts
export const setRelatedContracts = createAction(
    `${SOURCE} SetRelatedContracts`, props<{ relatedContracts: ContractRelatedDto[] }>()
)
// Payments
export const loadOutgoingPayments = createAction(
    `${SOURCE} LoadOutgoingPayments`, props<{ contractId: number }>()
)
export const loadIncomingPayments = createAction(
    `${SOURCE} LoadIncomingPayments`, props<{ contractId: number }>()
)
export const setOutgoingPayments = createAction(
    `${SOURCE} SetOutgoingPayments`, props<{ outgoingPaymentsGrouped: OutgoingPaymentGroupedByYearContractDto[] }>()
)
export const setIncomingPayments = createAction(
    `${SOURCE} SetIncomingPayments`, props<{ incomingPayments: IncomingPaymentDto[] }>()
)
export const setCurrentYearPaymentReady = createAction(
    `${SOURCE} SetContractCurrentYearPaymentReady`, props<{ currentYearPaymentReady: boolean }>()
)

export const setContractSignatureDocuments = createAction(
    `${SOURCE} SetContractSignatureDocuments`, props<{ signatureDocuments: ContractSignatureDocumentDto[] }>()
)

export const setContractSignatureDocumentsGroup = createAction(
    `${SOURCE} SetContractSignatureDocumentsGroup`, props<{ signatureDocuments: ContractSignatureDocumentDto[] }>()
)

// ContractGroups
export const setContractGroups = createAction(
    `${SOURCE} SetContractGroups`, props<{ contractGroups: ContractGroupDto[] }>()
)
export const setAllowEdit = createAction(
    `${SOURCE} SetAllowEdit`, props<{ allowEdit: boolean }>()
)

export const setIsAppendix = createAction(
    `${SOURCE} SetIsAppendix`, props<{ isAppendix: boolean }>()
)

export const setSameLvAndKatuze = createAction(
    `${SOURCE} SetSameLvAndKatuze`, props<{ sameLVAndKatuze: boolean }>()
)

export const setSuccessiveContractAvailable = createAction(
    `${SOURCE} SetSuccessiveContractAvailable`, props<{ successiveContractAvailable: boolean }>()
)

export const setParcelsOrder = createAction(
    `${SOURCE} SetParcelsOrder`, props<{ parcelsOrder: {sortedBy: string; desc: boolean} }>()
)

export const prepareAndSetContract = createAction(
    `${ SOURCE } PrepareAndSetContract`, props<{ contract: any }>(),
)

export const loadContractOwnersRepresentatives = createAction(
    `${ SOURCE } LoadContractOwnersRepresentatives`,
)

export const loadContractTenantsRepresentatives = createAction(
    `${ SOURCE } loadContractTenantsRepresentatives`,
)
